// bluaIQ — Cuantificación (Takeoff) availability switch.
//
// Decision (Blu, 2026-10-21): the platform is sold WITHOUT the Cuantificación
// module for now, but the module is NOT removed — it must be switchable back
// on, because takeoff also feeds the Gantt and is the baseline to compare
// contractor/supplier budgets against. This file is the single reversible
// switch for every customer-facing takeoff surface.
//
//   * Owner accounts (Clerk publicMetadata.takeoffOwner === true) ALWAYS see
//     takeoff, exactly as before.
//   * Everyone else sees it only when the build sets
//     VITE_TAKEOFF_PUBLIC_ENABLED=true (Vercel env). Default: OFF.
//
// Turning it back on for customers = set the env var and redeploy. No code,
// route, data or component is deleted while it is off.

function readPublicFlag(): boolean {
  // Vite injects import.meta.env at build time; guard for non-Vite runtimes
  // (tsx smoke tests), same pattern as clientFlags.ts.
  // Codex #534 [P1]: Vite sustituye el texto EXACTO `import.meta.env.VITE_*`
  // al compilar. Guardar `import.meta` en una variable rompía la sustitución
  // y en el navegador el flag salía siempre false (no se podía volver a
  // encender). Se lee directo; en tsx (sin Vite) import.meta.env no existe y
  // el try devuelve false.
  try {
    return import.meta.env.VITE_TAKEOFF_PUBLIC_ENABLED === 'true'
  } catch (_) {
    return false
  }
}

/** True when Cuantificación is switched on for ALL customers (build flag). */
export function isTakeoffPublicEnabled(): boolean {
  return readPublicFlag()
}

/** True when this user may see/use Cuantificación surfaces. */
export function isTakeoffAvailable(isTakeoffOwner: boolean): boolean {
  return isTakeoffOwner === true || readPublicFlag()
}
